// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1NRn2","title":"ClientInsurance_title__mvKNz","itemText":"ClientInsurance_itemText__1aI_E"};